import { Route } from "@angular/router";
import { AppComponent } from "./app.component";

export const Routes: Route[] = [
    {
        path: '**',
        component: AppComponent
    }
];


// WEBPACK FOOTER //
// /home/kepler/code/github/expense-manager-firebase/src/app/app-routes.ts